import { combineReducers } from 'redux'
import backendDataReducer from './backendDataReducer'
import answerModelReducer from './answerModelReducer'

export default combineReducers({
	backendDataReducer, 
	answerModelReducer
})